var _mask, _g, _path, _path2, _g2, _g3, _g4, _g5, _path3, _g6, _g7, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIphone12Black(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 608,
    viewBox: "0 0 300 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 296,
    height: 608
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06885 68.8552C2.06885 44.7536 2.06885 32.7028 6.75933 23.4972C10.8852 15.3998 17.4686 8.81634 25.5661 4.69048C34.7717 0 46.8224 0 70.924 0H229.076C253.177 0 265.228 0 274.434 4.69048C282.531 8.81634 289.115 15.3998 293.24 23.4972C297.931 32.7028 297.931 44.7536 297.931 68.8552V538.179C297.931 562.281 297.931 574.332 293.24 583.537C289.115 591.635 282.531 598.218 274.434 602.344C265.228 607.034 253.177 607.034 229.076 607.034H70.924C46.8224 607.034 34.7717 607.034 25.5661 602.344C17.4686 598.218 10.8852 591.635 6.75933 583.537C2.06885 574.332 2.06885 562.281 2.06885 538.179V68.8552Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06885 68.8552C2.06885 44.7536 2.06885 32.7028 6.75933 23.4972C10.8852 15.3998 17.4686 8.81634 25.5661 4.69048C34.7717 0 46.8224 0 70.924 0H229.076C253.177 0 265.228 0 274.434 4.69048C282.531 8.81634 289.115 15.3998 293.24 23.4972C297.931 32.7028 297.931 44.7536 297.931 68.8552V538.179C297.931 562.281 297.931 574.332 293.24 583.537C289.115 591.635 282.531 598.218 274.434 602.344C265.228 607.034 253.177 607.034 229.076 607.034H70.924C46.8224 607.034 34.7717 607.034 25.5661 602.344C17.4686 598.218 10.8852 591.635 6.75933 583.537C2.06885 574.332 2.06885 562.281 2.06885 538.179V68.8552Z",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.06885 68.8552C3.06885 56.7879 3.06963 47.7976 3.65184 40.6716C4.23309 33.5574 5.38889 28.3895 7.65033 23.9512C11.6803 16.0419 18.1108 9.61147 26.0201 5.58148C30.4584 3.32005 35.6262 2.16425 42.7405 1.58299C49.8664 1.00078 58.8567 1 70.924 1H229.076C241.143 1 250.133 1.00078 257.259 1.58299C264.374 2.16425 269.541 3.32005 273.98 5.58149C281.889 9.61147 288.319 16.0419 292.349 23.9512C294.611 28.3895 295.767 33.5574 296.348 40.6716C296.93 47.7976 296.931 56.7879 296.931 68.8552V538.179C296.931 550.247 296.93 559.237 296.348 566.363C295.767 573.477 294.611 578.645 292.349 583.083C288.319 590.993 281.889 597.423 273.98 601.453C269.541 603.714 264.374 604.87 257.259 605.451C250.133 606.034 241.143 606.034 229.076 606.034H70.924C58.8567 606.034 49.8664 606.034 42.7405 605.451C35.6262 604.87 30.4584 603.714 26.0201 601.453C18.1108 597.423 11.6803 590.993 7.65033 583.083C5.38889 578.645 4.23309 573.477 3.65184 566.363C3.06963 559.237 3.06885 550.247 3.06885 538.179V68.8552Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.413818,
    y: 51.7241,
    width: 7.03448,
    height: 5.7931,
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.413818,
    y: 552,
    width: 7.03448,
    height: 5.7931,
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.552,
    y: 51.7241,
    width: 7.03448,
    height: 5.7931,
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.552,
    y: 552,
    width: 7.03448,
    height: 5.7931,
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.034,
    y: -2.89648,
    width: 7.03448,
    height: 5.7931,
    transform: "rotate(90 235.034 -2.89648)",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.8276,
    y: 601.655,
    width: 7.03448,
    height: 5.7931,
    transform: "rotate(90 60.8276 601.655)",
    fill: "url(#paint6_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.6001 3.56055H230.4C241.644 3.56055 250.062 3.56074 256.742 4.10656C263.42 4.65215 268.34 5.74164 272.592 7.90807C280.097 11.7323 286.199 17.8343 290.023 25.3397C292.19 29.5916 293.279 34.5115 293.825 41.1891C294.371 47.8696 294.371 56.2874 294.371 67.5312V539.504C294.371 550.747 294.371 559.165 293.825 565.846C293.279 572.523 292.19 577.443 290.023 581.695C286.199 589.201 280.097 595.303 272.592 599.127C268.34 601.293 263.42 602.383 256.742 602.928C250.062 603.474 241.644 603.474 230.4 603.474H69.6001C58.3563 603.474 49.9385 603.474 43.2579 602.928C36.5803 602.383 31.6605 601.293 27.4086 599.127C19.9032 595.303 13.8011 589.201 9.97692 581.695C7.81048 577.443 6.72099 572.523 6.17541 565.846C5.62959 559.165 5.62939 550.747 5.62939 539.504V67.5312C5.62939 56.2874 5.62959 47.8696 6.17541 41.1891C6.72099 34.5115 7.81048 29.5916 9.97692 25.3397C13.8011 17.8343 19.9032 11.7323 27.4086 7.90807C31.6605 5.74164 36.5803 4.65215 43.2579 4.10656C49.9385 3.56074 58.3563 3.56055 69.6001 3.56055Z",
    fill: "black",
    stroke: "url(#paint7_linear)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6186 30.2601C16.5518 36.2791 16.5518 44.1585 16.5518 59.9172V547.117C16.5518 562.876 16.5518 570.755 19.6186 576.774C22.3163 582.069 26.6208 586.373 31.9153 589.071C37.9344 592.138 45.8137 592.138 61.5724 592.138H238.428C254.186 592.138 262.066 592.138 268.085 589.071C273.379 586.373 277.684 582.069 280.381 576.774C283.448 570.755 283.448 562.876 283.448 547.117V59.9172C283.448 44.1585 283.448 36.2791 280.381 30.2601C277.684 24.9656 273.379 20.661 268.085 17.9633C262.066 14.8965 254.186 14.8965 238.428 14.8965H224.598C223.913 14.8965 223.57 14.8965 223.296 14.9963C222.836 15.1636 222.474 15.5258 222.307 15.9856C222.207 16.2598 222.207 16.6023 222.207 17.2873C222.207 22.7672 222.207 25.5072 221.408 27.7012C220.07 31.3792 217.172 34.2765 213.494 35.6152C211.3 36.4137 208.56 36.4137 203.08 36.4137H96.9196C91.4397 36.4137 88.6997 36.4137 86.5057 35.6152C82.8277 34.2765 79.9304 31.3792 78.5917 27.7012C77.7931 25.5072 77.7931 22.7672 77.7931 17.2873C77.7931 16.6023 77.7931 16.2598 77.6933 15.9856C77.526 15.5258 77.1638 15.1636 76.7041 14.9963C76.4298 14.8965 76.0873 14.8965 75.4023 14.8965H61.5724C45.8137 14.8965 37.9344 14.8965 31.9153 17.9633C26.6208 20.661 22.3163 24.9656 19.6186 30.2601Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iiii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 96.8276C0 96.3705 0.370523 96 0.827586 96H2.06897V120H0.827586C0.370523 120 0 119.629 0 119.172V96.8276Z",
    fill: "url(#paint8_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iiii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 140.276C0 139.819 0.370523 139.448 0.827586 139.448H2.06897V185.793H0.827586C0.370523 185.793 0 185.423 0 184.965V140.276Z",
    fill: "url(#paint9_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_iiii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.931 156H299.173C299.63 156 300 156.371 300 156.828V227.172C300 227.629 299.63 228 299.173 228H297.931V156Z",
    fill: "url(#paint10_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_iiii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 196.965C0 196.508 0.370523 196.138 0.827586 196.138H2.06897V242.483H0.827586C0.370523 242.483 0 242.112 0 241.655V196.965Z",
    fill: "url(#paint11_linear)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6186 30.2601C16.5518 36.2791 16.5518 44.1585 16.5518 59.9172V547.117C16.5518 562.876 16.5518 570.755 19.6186 576.774C22.3163 582.069 26.6208 586.373 31.9153 589.071C37.9344 592.138 45.8137 592.138 61.5724 592.138H238.428C254.186 592.138 262.066 592.138 268.085 589.071C273.379 586.373 277.684 582.069 280.381 576.774C283.448 570.755 283.448 562.876 283.448 547.117V59.9172C283.448 44.1585 283.448 36.2791 280.381 30.2601C277.684 24.9656 273.379 20.661 268.085 17.9633C262.066 14.8965 254.186 14.8965 238.428 14.8965H224.598C223.913 14.8965 223.57 14.8965 223.296 14.9963C222.836 15.1636 222.474 15.5258 222.307 15.9856C222.207 16.2598 222.207 16.6023 222.207 17.2873C222.207 22.7672 222.207 25.5072 221.408 27.7012C220.07 31.3792 217.172 34.2765 213.494 35.6152C211.3 36.4137 208.56 36.4137 203.08 36.4137H96.9196C91.4397 36.4137 88.6997 36.4137 86.5057 35.6152C82.8277 34.2765 79.9304 31.3792 78.5917 27.7012C77.7931 25.5072 77.7931 22.7672 77.7931 17.2873C77.7931 16.6023 77.7931 16.2598 77.6933 15.9856C77.526 15.5258 77.1638 15.1636 76.7041 14.9963C76.4298 14.8965 76.0873 14.8965 75.4023 14.8965H61.5724C45.8137 14.8965 37.9344 14.8965 31.9153 17.9633C26.6208 20.661 22.3163 24.9656 19.6186 30.2601Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.069 22.7589C134.069 21.1591 135.366 19.8623 136.966 19.8623H163.448C165.048 19.8623 166.345 21.1591 166.345 22.7589C166.345 24.3586 165.048 25.6554 163.448 25.6554H136.966C135.366 25.6554 134.069 24.3586 134.069 22.7589Z",
    fill: "#161616"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.069 22.7589C135.069 21.7114 135.918 20.8623 136.966 20.8623H163.448C164.496 20.8623 165.345 21.7114 165.345 22.7589C165.345 23.8063 164.496 24.6554 163.448 24.6554H136.966C135.918 24.6554 135.069 23.8063 135.069 22.7589Z",
    stroke: "black",
    strokeOpacity: 0.32,
    strokeWidth: 2
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.569 22.7589C134.569 21.4353 135.642 20.3623 136.966 20.3623H163.448C164.772 20.3623 165.845 21.4353 165.845 22.7589C165.845 24.0824 164.772 25.1554 163.448 25.1554H136.966C135.642 25.1554 134.569 24.0824 134.569 22.7589Z",
    stroke: "url(#paint12_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.966 22.7589C172.966 19.5595 175.559 16.9658 178.759 16.9658C181.958 16.9658 184.552 19.5595 184.552 22.7589C184.552 25.9584 181.958 28.552 178.759 28.552C175.559 28.552 172.966 25.9584 172.966 22.7589Z",
    fill: "url(#paint13_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.966 22.7589C172.966 19.5595 175.559 16.9658 178.759 16.9658C181.958 16.9658 184.552 19.5595 184.552 22.7589C184.552 25.9584 181.958 28.552 178.759 28.552C175.559 28.552 172.966 25.9584 172.966 22.7589Z",
    fill: "url(#paint14_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.655 22.7589C181.655 21.1591 180.359 19.8623 178.759 19.8623C177.159 19.8623 175.862 21.1591 175.862 22.7589C175.862 24.3586 177.159 25.6554 178.759 25.6554C180.359 25.6554 181.655 24.3586 181.655 22.7589Z",
    fill: "url(#paint15_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.655 22.7589C181.655 21.1591 180.359 19.8623 178.759 19.8623C177.159 19.8623 175.862 21.1591 175.862 22.7589C175.862 24.3586 177.159 25.6554 178.759 25.6554C180.359 25.6554 181.655 24.3586 181.655 22.7589Z",
    fill: "url(#paint16_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.655 22.7589C181.655 21.1591 180.359 19.8623 178.759 19.8623C177.159 19.8623 175.862 21.1591 175.862 22.7589C175.862 24.3586 177.159 25.6554 178.759 25.6554C180.359 25.6554 181.655 24.3586 181.655 22.7589Z",
    fill: "url(#paint17_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.655 22.7589C181.655 21.1591 180.359 19.8623 178.759 19.8623C177.159 19.8623 175.862 21.1591 175.862 22.7589C175.862 24.3586 177.159 25.6554 178.759 25.6554C180.359 25.6554 181.655 24.3586 181.655 22.7589Z",
    fill: "url(#paint18_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.655 22.7589C181.655 21.1591 180.359 19.8623 178.759 19.8623C177.159 19.8623 175.862 21.1591 175.862 22.7589C175.862 24.3586 177.159 25.6554 178.759 25.6554C180.359 25.6554 181.655 24.3586 181.655 22.7589Z",
    fill: "url(#paint19_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii",
    x: 2.06885,
    y: 0,
    width: 295.862,
    height: 607.034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.88 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iiii",
    x: 0,
    y: 94,
    width: 2.06897,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iiii",
    x: 0,
    y: 137.448,
    width: 2.06897,
    height: 50.3448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_iiii",
    x: 297.931,
    y: 154,
    width: 2.06897,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_iiii",
    x: 0,
    y: 194.138,
    width: 2.06897,
    height: 50.3448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i",
    x: 134.069,
    y: 19.8623,
    width: 32.2759,
    height: 5.7931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 133.069,
    y: 18.8623,
    width: 34.2759,
    height: 7.7931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 607.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.32
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.413818,
    y1: 54.8276,
    x2: 7.4483,
    y2: 54.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.123628,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365738,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827659,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.413818,
    y1: 555.103,
    x2: 7.4483,
    y2: 555.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.123628,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365738,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827659,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 292.552,
    y1: 54.8276,
    x2: 299.586,
    y2: 54.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088176,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536358,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756584,
    stopColor: "#8F8F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 292.552,
    y1: 555.103,
    x2: 299.586,
    y2: 555.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088176,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529254,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770792,
    stopColor: "#8F8F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 235.034,
    y1: 0.206964,
    x2: 242.069,
    y2: 0.206964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.420124,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610413,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976264,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 60.8276,
    y1: 604.759,
    x2: 67.8621,
    y2: 604.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584624,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87589,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 23.8665,
    y1: 10.9843,
    x2: 272.067,
    y2: 588.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 0,
    y1: 107.793,
    x2: 2.06897,
    y2: 107.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 0,
    y1: 162.221,
    x2: 2.06897,
    y2: 162.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 297.931,
    y1: 191.379,
    x2: 300,
    y2: 191.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 0,
    y1: 218.911,
    x2: 2.06897,
    y2: 218.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 150.207,
    y1: 19.8623,
    x2: 150.207,
    y2: 25.6554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483028,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.793 25.4486) rotate(-127.694) scale(5.75232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.759 22.7589) rotate(90) scale(5.7931)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 178.759,
    y1: 19.8623,
    x2: 178.759,
    y2: 25.6554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B528D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#3625AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#070D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#16618F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021762"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.483 22.1382) rotate(58.3925) scale(3.15814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070D17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.173 23.1726) rotate(106.699) scale(2.16006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146834,
    stopColor: "#070D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070D17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.586 22.1382) rotate(128.66) scale(1.32478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6356D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15368A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.759 22.7589) rotate(90) scale(2.89655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.85
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone12Black);
export default __webpack_public_path__ + "static/media/iphone-12--black.cb3b75815a881533da7f0a351a5a95d5.svg";
export { ForwardRef as ReactComponent };